<template>
  <a
    class="pos-rel c-p"
    :href="link"
    target="_blank"
    @mouseenter="() => isHovering = true"
    @mouseleave="() => isHovering = false"
  >
    <MoviesPoster
      :movie="props.tmdbFilm || {}"
      :href="link"
      :title-override="props.letterboxdFilm.full_name"
      class="h-140"
    />
    <div
      v-if="isHovering"
      class="pos-abs top-0 left-0 h-100p w-100p bg-white o-8"
    >
      <div class="pos-abs bottom-0 left-0 p-x4">
        <div class="t-12 black">
          <span>{{ props.letterboxdFilm.full_name }}</span>
          <br />
          <br />
          <template v-for="user in props.letterboxdFilm.users" :key="user">
            <span>{{ user }}</span>
            <br />
          </template>
        </div>
      </div>
    </div>
    <div
      v-else-if="props.letterboxdFilm.disabled"
      class="pos-abs top-0 left-0 h-100p w-100p bg-white o-5"
    ></div>
  </a>
</template>

<script setup>
  import { ref } from 'vue';

  const props = defineProps({
    letterboxdFilm: { type: Object, required: true },
    tmdbFilm: { type: Object, default: () => {} },
  });

  const isHovering = ref(false);
  const link = `https://www.letterboxd.com${props.letterboxdFilm.link}`;
</script>